import type {BaseConfig, Batch} from './types';

import {expandObj} from '../../../api/utils/expand';
import {makeExpandFromBatchConfig} from './makeExpandFromBatchConfig';

export function expandBatchResponse<Config extends Batch<BaseConfig<any>>>(
  response,
  config: Config,
) {
  if (config.preventExpand) {
    return response;
  }

  const _expand = makeExpandFromBatchConfig(config);

  return response
    .map((batchItem, index) =>
      batchItem._items.map(item =>
        expandObj(item, {
          expand: _expand[index] ?? _expand[0],
          expanded: batchItem._expanded,
        }),
      ),
    )
    .flat();
}

export function expandResponse<
  Config extends BaseConfig<any> = BaseConfig<any>,
>(response, config: Config) {
  if (config.preventExpand) {
    return response;
  }

  return response._items.map(item =>
    expandObj(item, {
      expand: config.params.expand ?? {},
      expanded: response._expanded,
    }),
  );
}
